import React, { useEffect, useState } from "react";
import { ArrowRight, Sparkles, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { loadProfileLocal } from "@/components/assessment/assessmentScoring";

const DISMISS_KEY = "forr:assessment-companion-prompt:dismissed";

const AssessmentCompanionPrompt = () => {
  const location = useLocation();
  const [profileReady, setProfileReady] = useState(false);
  const [promptReady, setPromptReady] = useState(false);
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === "true";
    } catch (_error) {
      return false;
    }
  });

  useEffect(() => {
    const saved = () => {
      setProfileReady(Boolean(loadProfileLocal()));
      setPromptReady(true);
      setDismissed(false);
      try {
        sessionStorage.removeItem(DISMISS_KEY);
      } catch (_error) {
        // The prompt still works without session storage.
      }
    };
    const cleared = () => {
      setProfileReady(false);
      setPromptReady(false);
    };
    window.addEventListener("adaptive-profile-saved", saved);
    window.addEventListener("adaptive-profile-cleared", cleared);
    return () => {
      window.removeEventListener("adaptive-profile-saved", saved);
      window.removeEventListener("adaptive-profile-cleared", cleared);
    };
  }, []);

  if (location.pathname !== "/assessment/start" || !profileReady || !promptReady || dismissed) {
    return null;
  }

  const dismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(DISMISS_KEY, "true");
    } catch (_error) {
      // No persistence is required.
    }
  };

  return (
    <aside className="fixed inset-x-4 bottom-4 z-[90] mx-auto max-w-4xl rounded-[26px] p-5 shadow-2xl forr-panel-action sm:p-6" aria-label="APOS Companion coming soon" data-testid="assessment-companion-install-prompt">
      <button type="button" onClick={dismiss} className="absolute right-4 top-4 rounded-full bg-white/70 p-2 forr-text-mute" aria-label="Dismiss Companion prompt">
        <X size={16} />
      </button>
      <div className="flex flex-col gap-6 pr-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex items-start gap-4">
          <div className="rounded-2xl bg-white p-3"><Sparkles size={22} className="forr-text-teal-deep" /></div>
          <div>
            <div className="forr-overline">Assessment complete</div>
            <h2 className="mt-2 font-display text-2xl forr-text-ink">Your Adaptive Profile is saved.</h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed forr-text-soft">
              You can return to these results anytime. When APOS Companion access opens, the same profile will be ready to support check-ins, matched actions, planning, and progress.
            </p>
          </div>
        </div>
        <Link to="/app" className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium forr-btn-primary">
          Save my place <ArrowRight size={16} />
        </Link>
      </div>
    </aside>
  );
};

export default AssessmentCompanionPrompt;
